import * as React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  Button,
  Divider,
  Avatar,
} from "@mui/material";

const InfoRow = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2">{value || "—"}</Typography>
  </Grid>
);

const GoEasyCarBookingInfo = ({ open, onClose, data }) => {
  if (!data) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Booking Details</DialogTitle>

      <DialogContent dividers>
        {/* Car Image + Basic Info */}
        <Grid container spacing={2} alignItems="center">
          <Grid item>
            <Avatar
              variant="rounded"
              src={data.car_image}
              sx={{
                width: 120,
                height: 80,
                bgcolor: "#f5f5f5",
                "& img": {
                  objectFit: "contain",
                },
              }}
            />
          </Grid>
          <Grid item xs>
            <Typography variant="h6">
              {data.car_brand} {data.car_model} ({data.car_year})
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {data.car_type} • {data.car_transmission} • {data.car_fuel}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Customer Info */}
        <Typography fontWeight={"bold"} variant="subtitle1" gutterBottom>
          Customer Information
        </Typography>
        <Grid container spacing={2}>
          <InfoRow
            label="Name"
            value={`${data.first_name} ${data.last_name}`}
          />
          <InfoRow label="Email" value={data.email} />
          <InfoRow label="Contact No" value={data.contact_no} />
          <InfoRow label="CNIC" value={data.cnic} />
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Booking Info */}
        <Typography fontWeight={"bold"} variant="subtitle1" gutterBottom>
          Booking Information
        </Typography>
        <Grid container spacing={2}>
          <InfoRow label="From" value={data.from_location} />
          <InfoRow label="To" value={data.to_location} />
          <InfoRow label="Start Date" value={data.start_date} />
          <InfoRow label="End Date" value={data.end_date} />
          <InfoRow label="Pick Up Time" value={data.pick_up_time} />
          <InfoRow label="Passengers" value={data.no_of_passengers} />
          <InfoRow label="Vehicle Qty" value={data.vehicle_qty} />
          <InfoRow label="Per Day Rate" value={`Rs ${data.car_per_day_rate}`} />
          <InfoRow label="Status" value={data.status} />
        </Grid>

        <Divider sx={{ my: 2 }} />

        {/* Driver Info */}
        <Typography fontWeight={"bold"} variant="subtitle1" gutterBottom>
          Driver Information
        </Typography>
        <Grid container spacing={2}>
          <InfoRow label="Driver Name" value={data.driver_name} />
          <InfoRow label="Driver Contact" value={data.driver_contact_no} />
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default GoEasyCarBookingInfo;
